import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import ApiService from '../Services/ApiService';

const useVerifiedUserAuth0 = () => {
    const { isAuthenticated, getAccessTokenSilently, isLoading } = useAuth0();
    const [isVerified, setIsVerified] = useState(null)
    const [isLoadingVerify, setIsLoadingVerify] = useState(true)
    const { REACT_APP_APILOGIN } = process.env;

    useEffect(async () => {
        if (!isLoading) {
            setIsLoadingVerify(false)
            if (isAuthenticated) {
                const accessToken = await getAccessTokenSilently();
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`,
                };
                ApiService.getWithHeaders(
                    `${REACT_APP_APILOGIN}Auth0/GetUserInfo`,
                    headers
                ).then((response) => {
                    if (response.response?.email_verified) {
                        setIsVerified(true);
                    } else {
                        setIsVerified(false);
                    }
                });
            }
        }
    }, [isAuthenticated, isLoading])

    return [isVerified, isLoadingVerify]
}
export default useVerifiedUserAuth0